import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAdminConsole } from '@components/settings/actions';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { FormControl, FormControlLabel } from '@mui';
import './settings.scss';

const AdminConsole = () => {
  const { global: { admin_console } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const onChange = event => dispatch(updateAdminConsole(event.target.value));

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <div styleName="text">Admin Console</div>
      </div>
      <div styleName="hint">
        Switch between the old and new admin console design.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <RadioGroup aria-label="admin-console" name="admin_console" value={admin_console} onChange={onChange}>
            <FormControlLabel value="old" control={<Radio color="primary" />} label="Old Admin Console" />
            <FormControlLabel value="default" control={<Radio color="primary" />} label="New Admin Console" />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default memo(AdminConsole);
